import React, { Component } from 'react';
import MainProfile from './MainProfile.jsx';
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'redux';
import { Button } from '@material-ui/core';
import UpdateProfile from './UpdateProfile.jsx';
import { FormattedMessage, injectIntl } from 'react-intl';
import { ROLE_CUSTOMER, ROLE_PROVIDER } from '../../utils/config/constants.js';
import { withRouter } from 'react-router-dom';

const styles = theme => ({
    card: {
        color: theme.palette.secondary.main
    }
});
const sendProps = props => {
    const { classes, ...rest } = props;
    return rest;
};
class Profile extends Component {
    constructor() {
        super();
        this.state = { update: false };
    }

    profileUpdate = () => {
        this.setState({ update: true });
    };
    showProfile = () => {
        this.setState({ update: false });
    };
    updateDone = () => {
        this.setState({ update: false });
        if (this.props.userData.role == ROLE_CUSTOMER) {
            this.props.history.push(`/user/profile`);
        } else if (this.props.userData.role == ROLE_PROVIDER) {
            this.props.history.push(`/user/dashboard`);
        }
    };
    render() {
        const { userData } = this.props;
        return (
            <div className="tz-2-com tz-2-main h4-padding">
                <div>
                    {!this.state.update ? (
                        <h4 className="justify-content-between d-flex align-items-center">
                            {' '}
                            <FormattedMessage
                                id="customer.profile"
                                defaultMessage="My Profile"
                            />
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={this.profileUpdate}
                            >
                                <FormattedMessage
                                    id="customer.update"
                                    defaultMessage="Update"
                                />
                            </Button>
                        </h4>
                    ) : (
                        <h4 className="justify-content-between d-flex align-items-center">
                            {' '}
                            <FormattedMessage
                                id="customer.updateprofile"
                                defaultMessage="Update Profile"
                            />
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={this.showProfile}
                            >
                                <FormattedMessage
                                    id="customer.profile"
                                    defaultMessage="View Profile"
                                />
                            </Button>
                        </h4>
                    )}
                </div>
                <div className="db-list-com">
                    <div className="row">
                        <div className="col-md-12">
                            {!this.state.update ? (
                                <MainProfile {...sendProps(this.props)} />
                            ) : (
                                <UpdateProfile
                                    user={userData}
                                    updateDone={this.updateDone}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const composedProfile = compose(withStyles(styles));
export default composedProfile(withRouter(Profile));



// WEBPACK FOOTER //
// ./src/views/User/Profile.jsx